import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Hacer scroll al top cuando cambie la ruta
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant', // 'instant' para scroll inmediato, 'smooth' para suave
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
